import { Injectable } from '@angular/core';

import { SnackBarHelperComponent } from '../helpers/snack-bar-helper';
import { LocalStorageService } from '../services/local-storage.service';

@Injectable()
export class CreateNewProjectGuard {
	constructor(
		private localStorageService: LocalStorageService,
		private snack: SnackBarHelperComponent,
	) {}

	public canActivate(): boolean {
		const currentUser = this.localStorageService.getUserDetails();

		if (!currentUser?.providers?.length) {
			this.snack.snackError('You have not been assigned to any Companies. Please contact an Administrator.');
			return false;
		}

		return currentUser.entity.canCreateMoreProjects();
	}
}
